export const getModalList = state => state.modals || [];
